var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrownimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3922_11801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.77315 13.1106C1.39315 10.6394 1.01294 8.1681 0.632525 5.69685C0.613972 5.57541 0.631987 5.4512 0.684274 5.34004C0.736562 5.22888 0.820756 5.1358 0.926131 5.07265C1.03151 5.00951 1.15329 4.97916 1.27598 4.98547C1.39866 4.99178 1.51669 5.03447 1.61503 5.1081L5.16878 7.7731C5.26112 7.84239 5.36662 7.89211 5.47883 7.91922C5.59105 7.94634 5.70761 7.95027 5.8214 7.93079C5.93519 7.91131 6.04381 7.86882 6.14061 7.80592C6.23741 7.74302 6.32037 7.66104 6.3844 7.56498L9.34315 3.12498C9.41528 3.01708 9.5129 2.92863 9.62736 2.86746C9.74183 2.80629 9.86961 2.77429 9.9994 2.77429C10.1292 2.77429 10.257 2.80629 10.3714 2.86746C10.4859 2.92863 10.5835 3.01708 10.6557 3.12498L13.6144 7.56248C13.6784 7.65854 13.7614 7.74052 13.8582 7.80342C13.955 7.86632 14.0636 7.90881 14.1774 7.92829C14.2912 7.94777 14.4078 7.94384 14.52 7.91672C14.6322 7.88961 14.7377 7.83989 14.83 7.7706L18.3838 5.1056C18.4821 5.03197 18.6001 4.98928 18.7228 4.98297C18.8455 4.97666 18.9673 5.00701 19.0727 5.07015C19.178 5.1333 19.2622 5.22638 19.3145 5.33754C19.3668 5.4487 19.3848 5.57292 19.3663 5.69435C18.9859 8.1656 18.6057 10.6369 18.2257 13.1081L1.77315 13.1106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77313 14.4819H18.2269V16.3663C18.2269 16.479 18.2047 16.5906 18.1616 16.6947C18.1184 16.7988 18.0552 16.8934 17.9755 16.9731C17.8959 17.0528 17.8013 17.116 17.6971 17.1591C17.593 17.2022 17.4814 17.2244 17.3688 17.2244H2.63126C2.40367 17.2244 2.1854 17.134 2.02447 16.9731C1.86354 16.8122 1.77313 16.5939 1.77313 16.3663V14.4819Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3922_11801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownimg);
export default __webpack_public_path__ + "static/media/crownimg.7e22ece766b6cad9931411bfa9b63699.svg";
export { ForwardRef as ReactComponent };